'use client';

import { c as _c } from "react/compiler-runtime";
import IconAlert from '@/components/assets/icon_alert.svg';
import DefaultAlertDialog from '@/components/DefaultAlertDialog';
import { AGE_GATE_STATUS, type AgeGateStatus } from '@/context/CheckEnterRoomContext';
import { useTranslations } from 'next-intl';
type AgeVerificationModalProps = {
  status: Extract<AgeGateStatus, 'not-signed-in' | 'underage'>;
  onLeave: () => void;
  onSignIn?: () => void;
};
export default function AgeVerificationModal(t0) {
  const $ = _c(21);
  const {
    status,
    onLeave,
    onSignIn
  } = t0;
  const t = useTranslations();
  const isNotSignedIn = status === AGE_GATE_STATUS.NOT_SIGNED_IN;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconAlert className="h-10 w-10 fill-[#F8E64A]" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("loading-screen.device-alert.title-age-verification");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isNotSignedIn || $[4] !== t) {
    t3 = isNotSignedIn ? t("loading-screen.device-alert.description-age-verification-sign-in") : t("loading-screen.device-alert.description-age-verification-underage");
    $[3] = isNotSignedIn;
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <p className="body1-omni-styles text-vive-primary-20">{t3}</p>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isNotSignedIn || $[9] !== t) {
    t5 = isNotSignedIn ? t("loading-screen.device-alert.leave-age-verification") : undefined;
    $[8] = isNotSignedIn;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isNotSignedIn || $[12] !== t) {
    t6 = isNotSignedIn ? t("loading-screen.device-alert.sign-in-age-verification") : t("loading-screen.device-alert.leave-age-verification-underage");
    $[11] = isNotSignedIn;
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = isNotSignedIn ? onLeave : undefined;
  const t8 = isNotSignedIn ? onSignIn : onLeave;
  let t9;
  if ($[14] !== t2 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = <DefaultAlertDialog open={true} titleIcon={t1} title={t2} content={t4} cancelText={t5} actionText={t6} onCancel={t7} onAction={t8} allowOutsideInteraction={true} />;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}